import * as React from 'react';
import { DisplayDate, differenceInDays } from 'owa-datetime';
import {
    AgendaEventViewBase,
    Detail,
    AgendaEventViewBaseProps,
    TextDetailPart,
} from 'owa-agenda-event-views';
import { getDurationString } from '../selectors/userConfigSelectors';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-agenda-strings';

const styles = require('./AgendaEventViewAllDay.scss');
const classNames = require('classnames/bind').bind(styles);
import { getCalendarEventIcons } from 'owa-calendar-event-icons';

export interface AllDayProps {
    startTime: DisplayDate;
    endTime: DisplayDate;
    subject: string;
    isCancelled: boolean;
    hasAttachments: boolean;
    isRecurring: boolean;
    isPrivate: boolean;
    isRecurringException: boolean;
    charmId: number;
}

export type AgendaEventViewAllDayProps = Omit<
    AgendaEventViewBaseProps,
    'details' | 'timeDetails' | 'icons'
> &
    AllDayProps;

function withNormalView(
    AgendaEventViewBase: React.ComponentClass<AgendaEventViewBaseProps>
): React.ComponentType<AgendaEventViewAllDayProps> {
    const AgendaEventViewAllDay = observer(
        class extends React.Component<AgendaEventViewBaseProps & AllDayProps> {
            render() {
                const {
                    startTime,
                    endTime,
                    subject,
                    className,
                    isCancelled,
                    hasAttachments,
                    isRecurring,
                    isPrivate,
                    isRecurringException,
                    charmId,
                    ...passThroughProps
                } = this.props;
                const details: Detail[] = [];

                details.push({
                    getCharmControllProps: charmId
                        ? () => ({ iconId: charmId, className: styles.charm })
                        : null,
                    getTextProps: () => ({
                        text: subject,
                        className: classNames(styles.subject, { isCancelled: isCancelled }),
                    }),
                });

                const timeDetails: TextDetailPart[] = [
                    {
                        getTextProps: () => ({
                            text: strings.agendaEventAllDayText,
                            className: styles.timePrimaryText,
                        }),
                    },
                ];
                if (differenceInDays(endTime, startTime) > 1) {
                    timeDetails.push({
                        getTextProps: () => ({
                            text: getDurationString(startTime, endTime),
                            className: styles.timeSecondaryText,
                        }),
                    });
                }

                return (
                    <AgendaEventViewBase
                        {...passThroughProps}
                        details={details}
                        timeDetails={timeDetails}
                        className={className}
                        icons={getCalendarEventIcons(
                            hasAttachments,
                            isRecurring,
                            isPrivate,
                            isRecurringException
                        )}
                    />
                );
            }
        }
    );

    return AgendaEventViewAllDay;
}

export const AgendaEventViewAllDay = withNormalView(AgendaEventViewBase);
